import React from 'react';
import isNil from 'lodash/isNil';
import { MaybeNil } from '../../../../../utils/interfaces';
import {
  IBasicEventValueFieldsFragment,
  IFieldFieldsFragment,
} from '../../../../../utils/apollo/graphqlSchema';
import { BasicEntity } from '../../../../EntityLabels';
import styled from 'styled-components';
import { theme } from '../../../../../styles/theme';

const Placeholder = styled.div`
  color: ${theme.colors.secondary400};
`;

interface IProps {
  event: MaybeNil<IBasicEventValueFieldsFragment>;
  field: MaybeNil<IFieldFieldsFragment>;
  onClear: () => void;
  placeholder: string;
}

const ExpandEventValue = ({ event, field, onClear, placeholder }: IProps) => {
  if (isNil(event) || isNil(field)) {
    return <Placeholder>{placeholder}</Placeholder>;
  }

  const eventName = event?.value?.name ?? '';
  const fieldName = field?.name ?? '';

  return (
    <BasicEntity onClear={onClear}>
      {eventName}[{fieldName}]
    </BasicEntity>
  );
};

export default ExpandEventValue;
